import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CurrencyFormatterPipe } from 'src/app/shared/pipe/currency-formatter.pipe';
import { IsValueExistPipe } from 'src/app/shared/pipe/is-value-exist.pipe';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import constants from 'src/constant.json';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-past-clients',
  templateUrl: './past-clients.component.html',
  styleUrls: ['./past-clients.component.scss'],
})
export class PastClientsComponent implements OnInit {
  filteredDashboardList: any[] = [];
  pastClientCardList = [
    {
      heading: 'Total Past Clients',
      key: 'totalPastClients',
      value: 0,
      text: '',
    },
    {
      heading: 'Total Transactions Amount',
      key: 'totalTransactionAmount',
      value: 0,
      text: '',
    },
    {
      heading: 'Low LTV Clients',
      key: 'lowLTVClients',
      value: '0',
      text: 'Having LTV < 30%',
    },
    {
      heading: 'Long Term Owners',
      key: 'longTermClients',
      value: 0,
      text: 'Owns More than 7 years',
    },
  ];

  selectedKeys = '';
  allowedKeys = ['lowLTVClients', 'longTermClients'];
  openCreateMailSheetValue: boolean = false;
  openAddContactNoteSheetValue: boolean = false;
  onDestroyNotifier$ = new Subject();
  isLTV: boolean;
  isLongTerm: boolean;
  constructor(
    public clientDashboardState: ClientDashboardState,
    private isValueExistPipe: IsValueExistPipe,
    public currencyFormatterPipe: CurrencyFormatterPipe,
    private subscriptionService: SubscriptionPlanService

  ) { }
  pastClientInfo: any;
  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options = {
    chart: {
      zoomType: 'xy',
    },
    title: {
      text: 'Past Performance Overview',
    },
    xAxis: {
      categories: [],
      title: {
        text: 'Year',
      },
    },
    yAxis: [
      {
        title: {
          text: 'Transaction Volume',
        },
      },
      {
        title: {
          text: 'Value / Commission',
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    series: [
      {
        name: 'Transaction Volume',
        type: 'column',
        data: [],
      },
      {
        name: 'Transaction Value',
        type: 'line',
        yAxis: 1,
        dashStyle: 'Dot', // 👈 dotted line
        data: [],
      },
      {
        name: 'Commission',
        type: 'line',
        yAxis: 1,
        data: [],
      },
    ],
  };

  ngOnInit(): void {
    this.clientDashboardState.pastClientList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.pastClientInfo = res;
        if (res.data && res.data.length > 0) {
          const agg = this.getYearWiseAggregates(res.data);
          this.updateDynamicValues();
        }
      }
    });
     this.clientDashboardState.openAddContactNoteSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openAddContactNoteSheetValue = status;
    });
    this.clientDashboardState.openCreateMailSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openCreateMailSheetValue = status;
    });

  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  selectCard(key: string) {
    if (!this.allowedKeys.includes(key)) {
      return;
    }
    this.selectedKeys = key;
  }

  getCardValue(card) {
    this.isLTV = false;
    this.isLongTerm = false;
    if (this.selectedKeys == 'lowLTVClients') {
      this.isLTV = true;
    }
    if (this.selectedKeys == 'longTermClients') {
      this.isLongTerm = true;
    }
  }

  resetFilter(event) {
    this.selectedKeys = ''
    this.isLTV = false;
    this.isLongTerm = false;
  }

  updateDynamicValues() {
    this.pastClientCardList[0].value = this.pastClientInfo.totalPastClient;
    // this.pastClientCardList[1].value = this.currencyFormatterPipe.transform(
    //   this.isValueExistPipe.transform(this.pastClientInfo.totalTransactions)
    // );
    this.pastClientCardList[1].value  = this.formatAmount(this.pastClientInfo.totalTransactions || 0 )
    // this.pastClientCardList[1].text = `Estimated Commission Amount : this.formatAmount(this.pastClientInfo.estimatedCommisionEarned || 0 )
this.pastClientCardList[1].text = `Estimated Commission Amount: ${this.formatAmount(
  this.pastClientInfo?.estimatedCommisionEarned || 0
)}`;
   // )}`;
    this.pastClientCardList[2].value = this.pastClientInfo.lowLtvClients;
    this.pastClientCardList[3].value = this.pastClientInfo.longTermOwners;
  }
  getYearWiseAggregates(data) {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 19;

    const temp = [];
    for (let y = startYear; y <= currentYear; y++) {
      temp.push({
        year: y.toString(),
        transaction: 0,
        price: 0,
        commission: 0,
      });
    }

    data?.forEach((item) => {
      if (!item.closeDate) return;

      const year = new Date(item.closeDate).getFullYear();
      if (year >= startYear && year <= currentYear) {
        const idx = year - startYear;
        temp[idx].transaction++;
        temp[idx].price += item.closePrice || 0;
        temp[idx].commission += (item.closePrice || 0) * 0.03;
      }
    });

    const yearsWithData = temp.filter((i) => i.transaction || i.price || i.commission);

    let finalData = temp;
    if (yearsWithData.length > 0 && yearsWithData.length < 5) {
      const firstYear = currentYear - 4;
      finalData = temp.filter((i) => Number(i.year) >= firstYear && Number(i.year) <= currentYear);
    } else if (yearsWithData.length >= 5) {
      const firstDataYear = Number(yearsWithData[0].year);
      finalData = temp.filter((i) => Number(i.year) >= firstDataYear && Number(i.year) <= currentYear);
    }

    const result = {
      categories: finalData.map((i) => i.year),
      transactionCounts: finalData.map((i) => i.transaction),
      totalPriceSums: finalData.map((i) => i.price),
      totalCommissionSums: finalData.map((i) => i.commission),
    };

    this.renderChart(result);
  }

  renderChart(agg: any) {
    const currencyPipe = this.currencyFormatterPipe; //  pipe reference
    this.chartOptions = {
      ...this.chartOptions,
      tooltip: {
        shared: true,
        formatter: function () {
          return this.points
            .map((p) => {
              if (p.series.name === 'Transaction Value' || p.series.name === 'Commission') {
                const val = currencyPipe.transform(p.y);
                return `<b>${p.series.name}</b>: ${val}`;
              }
              return `<b>${p.series.name}</b>: ${p.y}`;
            })
            .join('<br/>');
        },
      },

      xAxis: {
        categories: agg.categories,
      },
      series: [
        {
          name: 'Transaction Volume',
          type: 'column',
          data: agg.transactionCounts,
        },
        {
          name: 'Transaction Value',
          type: 'line',
          yAxis: 1,
          dashStyle: 'Dot',
          data: agg.totalPriceSums?.map((v) => Number(this.isValueExistPipe.transform(v))),
        },
        {
          name: 'Commission',
          type: 'line',
          yAxis: 1,
          data: agg.totalCommissionSums,
        },
      ],
    };
  }


  formatAmount(value: number | string): string {
  const amount = Number(String(value).replace(/[$,]/g, ''));
  if (isNaN(amount)) {
    return '$0';
  }
  if (Math.abs(amount) >= 1000000) {
    return `$${(amount / 1000000).toFixed(2)}M`;
  }
  if (Math.abs(amount) >= 1000) {
    return `$${(amount / 1000).toFixed(2)}K`;
  }
  return `$${amount.toLocaleString('en-US')}`;
}

  checkFeatureAccess(feature: string): boolean {
    return this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES[feature].key, false);
  }

}
